import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useTranslation } from "react-i18next";
import { getTheme2SearchFilterFieldCss } from "utils/theme2MultiSelect";
import { getStickyStockTableStickyColumnCss } from "utils/reactTableTheme";

const STICKY_STOCK_TABLE_COLUMN_CSS = getStickyStockTableStickyColumnCss();

const SEARCH_TENANTS_PAGE_STYLES = (isTheme2) => `
  ${isTheme2 ? `
  .search-tenants.search-tenants--theme2 .search-tenants-table-card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 0 !important;
  }
  ${getTheme2SearchFilterFieldCss({
    pageScopeSelector: ".search-tenants.search-tenants--theme2",
    filtersSelector: ".search-tenants-table-card .search-tenants-filters",
    rowClass: "search-tenants-filters-row",
    colClass: "search-tenants-filter-col",
  })}
  ` : ""}
  .search-tenants-card-header.card-header {
    padding-top: 2px;
    padding-bottom: 0;
  }
  .search-tenants-card-header h2,
  .search-tenants-card-header h4 {
    font-size: 16px !important;
    margin-bottom: 0;
    line-height: 1.2;
  }
  .search-tenants .align-items-center {
    margin-top: 3px;
  }
  .search-tenants:not(.search-tenants--theme2) .card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 10px !important;
  }
  .search-tenants.search-tenants--theme2 .card .card-body {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    padding-left: 15px;
    padding-right: 15px;
  }
  .sticky-stock-table .rt-table {
    width: 100%;
    min-width: 100%;
    border-collapse: collapse;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) {
    text-align: center !important;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child {
    text-align: right !important;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) .rt-resizable-header-content {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child).-cursor-pointer .rt-resizable-header-content {
    padding-right: 2em;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child .rt-resizable-header-content {
    text-align: right;
    width: 100%;
  }
  .sticky-stock-table .rt-tbody .rt-td:not(:last-child) {
    text-align: center;
    vertical-align: middle;
  }
  .sticky-stock-table .rt-tbody .rt-td:last-child {
    text-align: right;
    vertical-align: middle;
  }
  .sticky-stock-table .rt-tbody .rt-td:not(:last-child) > * {
    max-width: 100%;
    min-width: 0;
  }
  ${STICKY_STOCK_TABLE_COLUMN_CSS}
`;

const TenantListCards = ({ isTheme2, filters, table, tableHeader, headerActions, title }) => {
  const { t } = useTranslation();
  const pageTitle = title ?? t("routes.tenant");

  const titleHeader = (
    <CardHeader className="search-tenants-card-header">
      <div className="d-flex justify-content-between align-items-center">
        <h2 className="mb-0">{pageTitle}</h2>
        {headerActions}
      </div>
    </CardHeader>
  );

  return (
    <>
      <style>{SEARCH_TENANTS_PAGE_STYLES(isTheme2)}</style>
      {isTheme2 ? (
        <Card className="search-tenants-table-card">
          {titleHeader}
          <CardBody>
            <div className="search-tenants-filters">{filters}</div>
            {table}
          </CardBody>
        </Card>
      ) : (
        <>
          <Card>
            {titleHeader}
            <CardBody>{filters}</CardBody>
          </Card>
          <Card className="mt-2">
            {tableHeader ? <CardHeader>{tableHeader}</CardHeader> : null}
            <CardBody>{table}</CardBody>
          </Card>
        </>
      )}
    </>
  );
};

export default TenantListCards;
